'use client'

import type { Data } from '@repo/strapi'
import { OverviewTable } from '@/components/page-builder/global/pricingV1/overview/OverviewTable'
import { PlanTabs } from '@/components/page-builder/global/pricingV1/shared/PlanTabs'
import { cn } from '@/lib/styles'
import { PRICING_TEST_IDS } from '@/lib/test-ids'

export function PlanOverview({
	data,
	yearly,
	currentTab,
	setCurrentTab,
	stickyTopOffset,
}: {
	data?: Data.Component<'shared.pricing-plan-detail'>[] | null
	yearly?: boolean
	currentTab: string
	setCurrentTab: (value: string) => void
	stickyTopOffset?: number
}) {
	return (
		<div data-test-id={PRICING_TEST_IDS.LIST} className="bg-brand-black text-neutral-light-100">
			{/* Mobile */}
			<PlanTabs
				currentTab={currentTab}
				setCurrentTab={setCurrentTab}
				data={data}
				renderContent={(item) => (
					<OverviewTable
						data={data}
						currentTab={item.title}
						yearly={yearly}
						stickyTopOffset={stickyTopOffset}
					/>
				)}
				className="w-full py-3 lg:hidden"
			/>

			{/* Desktop */}
			<OverviewTable
				className={cn('hidden lg:block', !yearly && 'max-w-200 mx-auto')}
				data={data}
				yearly={yearly}
				stickyTopOffset={stickyTopOffset}
			/>
		</div>
	)
}
